import * as React from 'react';
import { CheckboxGroup, InputAdornment, TControlOptions } from '@cian/ui-kit';

import { Unit } from './components';
import { FormInputsLayout } from '../FormInputsLayout';

import * as styles from './styles.css';

export interface IPriceQuestionProps {
  value: string;
  selectedOptions?: string[];
  options?: TControlOptions | null;
  error: string;
  placeholder: string;
  unit?: string | null;
  inputName: string;

  onValueChange(value: string): void;

  onSelect?(selected: string[]): void;
}

export const PriceQuestion: React.FC<React.PropsWithChildren<IPriceQuestionProps>> = props => {
  const { placeholder, value, error, onValueChange, options, selectedOptions, onSelect, unit, inputName } = props;

  const handleValueChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: string) => onValueChange(value),
    [onValueChange],
  );
  const handleSelect = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, selected: string[]) => onSelect && onSelect(selected),
    [onSelect],
  );

  return (
    <div>
      <FormInputsLayout
        InputProps={{
          placeholder,
          value,
          errorMessage: error,
          invalid: !!error,
          onChange: handleValueChange,
          rightAdornment: <InputAdornment>{unit && <Unit text={unit} />}</InputAdornment>,
          name: inputName,
        }}
      />
      {options && !!options.length && (
        <div className={styles['options']}>
          <CheckboxGroup disabled={!value} options={options} onChange={handleSelect} value={selectedOptions} />
        </div>
      )}
    </div>
  );
};

PriceQuestion.displayName = 'PriceQuestion';
